import { Box, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function Brand() {
  const { t } = useTranslation('landing-page');
  const [clientHostname, setClientHostname] = useState('');

  useEffect(() => {
    const getHostname = () => {
      const hostname = decodeURIComponent(window.location.hostname).replace('www.', '');

      if (hostname === 'xn--wrmecheck-v2a.ch' || hostname === 'waermecheck.ch') {
        return 'wärmecheck.ch';
      }

      return hostname;
    };
    const newHostname = getHostname();
    setClientHostname(newHostname);
  }, []);

  return (
    <Box sx={{ width: '100%', mt: '60px', mb: '100px' }}>
      <Stack
        sx={{
          alignItems: { xs: 'center', md: 'flex-end' },
          mr: { md: '68px' },
          px: { xs: '12px', sm: 0 }
        }}
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontFamily: 'Panton, Montserrat, sans-serif',
            fontWeight: 800,
            fontSize: { xs: '28px', sm: '32px', md: '34px', lg: '46px', xl: '50px' }
          }}
        >
          {clientHostname}
        </Typography>

        <Typography
          variant="body1"
          color="white"
          sx={{
            fontWeight: 400,
            textAlign: { xs: 'center', md: 'left' }
          }}
        >
          {t('brand.description')}
        </Typography>
      </Stack>
    </Box>
  );
}

export default Brand;
